import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import {
  provideRouter,
  RouteReuseStrategy,
  TitleStrategy,
  withComponentInputBinding,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withRouterConfig,
} from '@angular/router';
import { StoreModule } from '@thiememeulenhoff/ng-store';
import { SecurityModule } from '@thiememeulenhoff/ng-security';
import {
  CustomRouteReuseStrategy,
  provideSentry,
  provideTham,
  provideUnleash,
} from '@thiememeulenhoff/ng-sdk';
import { PageTitleStrategy } from '../features/admin/_util/title.strategy';
import { ThasService } from '../features/admin/_services';
import { environment } from '../environments/environment';
import routes from '../app/app.routes';

const providers = [
  ...provideSentry,
  { provide: TitleStrategy, useClass: PageTitleStrategy },
  provideUnleash(environment.unleash),
  provideRouter(
    routes,
    withEnabledBlockingInitialNavigation(),
    withInMemoryScrolling({
      scrollPositionRestoration: 'enabled',
    }),
    withComponentInputBinding(),
    withRouterConfig({
      paramsInheritanceStrategy: 'always',
    }),
  ),
  { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
  importProvidersFrom(
    ThasService.GetConfiguredModule(),
    StoreModule.forRoot({
      environment: environment.auth.environment,
    }),
    SecurityModule.forRoot({
      environment: environment.auth.environment,
      clientId: environment.auth.clientId,
      clientSecret: environment.auth.clientSecret,
      useUserCookie: environment.auth.useUserCookie,
    }),
  ),
  provideTham({
    cdnDomain: environment.tham.proxyDomain,
  }),
];

export const appConfig: ApplicationConfig = { providers };
